import {
  instance as axios,
  setJwtToken,
  setMultiPartHeader,
} from "../../config/axiosInstance";

export const planListApi = async (data) => {
  const endPoint =
    `admin/subscription/list` + "?" + new URLSearchParams({ ...data }).toString();

  return await axios.get(endPoint, setJwtToken());
};

export const subscriptionPurchaseApi = async (data) => {
  const endPoint =
    `admin/subscription/purchase` + "?" + new URLSearchParams({ ...data }).toString();

  return await axios.get(endPoint, setJwtToken());
};

export const subscriptionTransactionListApi = async (data) => {
  const endPoint =
    `admin/subscription/transaction/list` + "?" + new URLSearchParams({ ...data }).toString();

  return await axios.get(endPoint, setJwtToken());
};

export const planDetailApi = async (data) => {
  const endPoint =
    `admin/subscription` + "?" + new URLSearchParams({ ...data }).toString();

  return await axios.get(endPoint, setJwtToken());
};

export const addSubscriptionApi = async (data) => {
  const endPoint = `admin/subscription`;
  return await axios.post(endPoint, data, setMultiPartHeader());
};

export const updateSubscriptionApi = async (data) => {
  const endPoint = `admin/subscription`;
  return await axios.put(endPoint, data, setMultiPartHeader());
};